import { render, staticRenderFns } from "./AProductTypeSelector.vue?vue&type=template&id=64726db7&"
import script from "./AProductTypeSelector.vue?vue&type=script&lang=js&"
export * from "./AProductTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports